unable to read source [project]/packages/analitica/src/lib/types.ts